export const SHARED_DEVICE_KEY = 'sharedDeviceStatus';
export const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;

export type SharedDeviceStatus = 'shared' | 'not_shared' | 'unknown';

export interface SharedDeviceRecord {
  status: SharedDeviceStatus;
  userId: string;
  lastActivityAt: number;
}

export function readSharedDeviceRecord(): SharedDeviceRecord | null {
  const raw = localStorage.getItem(SHARED_DEVICE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed === 'object' &&
      (parsed.status === 'shared' ||
        parsed.status === 'not_shared' ||
        parsed.status === 'unknown') &&
      typeof parsed.userId === 'string' &&
      typeof parsed.lastActivityAt === 'number'
    ) {
      return parsed as SharedDeviceRecord;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeSharedDeviceRecord(record: SharedDeviceRecord): void {
  localStorage.setItem(SHARED_DEVICE_KEY, JSON.stringify(record));
}
